<h1 class="page-title">My Demographics</h1>
<div *ngIf="reviewDemographics" style="color: red; font-weight: bold;"><p>Please review and update your demographic selections below.</p></div>
<p>Providing the requested background information is voluntary and will not be provided to any third party or otherwise be shared publicly. 
	Your participation is encouraged because this information will be used to evaluate the fairness of examination content.</p>

<form [formGroup]="profileForm" (ngSubmit)="onSubmit(profileForm.value)">
<!-- 	<div class="data-item">
		<div class="data-item__label label">Full Name</div>
		<div class="data-item__value">{{profile?.firstName}} <span *ngIf="profile?.middleName">{{profile?.middleName}} </span>{{profile?.lastName}}<span *ngIf="profile?.suffix">, {{profile?.suffix}}</span></div>
	</div> -->
	<div class="field">
		<div class="field__label-input-wrap">
			<label for="gender" class="label">With which of the following do you identify? </label>
			<select class="input input--select-menu input--xlarge" id="gender" name="gender" formControlName="gender" [class.input--invalid]="formErrors.gender">
				<option value="null">Select One</option>
				<option *ngFor="let c of genderLov" [value]="c.codeValue">{{c.codeDescription}}</option>
				<!-- <option value="F">Female</option>
				<option value="M">Male</option>
				<option value="N">Non-binary</option>
				<option value="P">Prefer not to say</option> -->
			</select>
			<div *ngIf="formErrors.gender" class="error-message field__error-message">{{ formErrors.gender }}</div>
		</div>
	</div>
	<div class="field">
		<div class="field__label-input-wrap">
			<label for="spanishOrigin" class="label">Do you identify with an Hispanic, Latino, or Spanish origin? </label>
			<select class="input input--xlarge input--select-menu " id="spanishOrigin" name="spanishOrigin" formControlName="spanishOrigin" [class.input--invalid]="formErrors.spanishOrigin">
				<option value="null">Select One</option>
				<option *ngFor="let c of spanishLov" [value]="c.codeValue">{{c.codeDescription}}</option>
<!-- 				<option value="0">No</option>
				<option value="1">Yes</option>
				<option value="9">Prefer not to say</option> -->
			</select>
			<div *ngIf="formErrors.spanishOrigin" class="error-message field__error-message">{{ formErrors.spanishOrigin }}</div>
		</div>
	</div>
	<div class="field">
		<div class="field__label-input-wrap">
			<label for="race" class="label">With which of the following do you PRIMARILY identify? </label>
			<select class="input input--select-menu input--xlarge" id="race" name="race" formControlName="race" [class.input--invalid]="formErrors.race">
				<option value="null">Select One</option>
				<option *ngFor="let c of raceLov" [value]="c.codeValue">{{c.codeDescription}}</option>
<!-- 				<option value="1">American Indian or Alaskan Native</option>
				<option value="2">Asian</option>
				<option value="3">Black or African American</option>
				<option value="4">Native Hawaiian or Other Pacific Islander</option>
				<option value="5">Two or More Races</option>
				<option value="6">White</option>
				<option value="9">Prefer not to say</option> -->
			</select>
			<div *ngIf="formErrors.race" class="error-message field__error-message">{{ formErrors.race }}</div>
		</div>
	</div>
	<section *ngIf="credentialed">
	<h1 class="page-title">My Practice</h1>
	<p>Providing the requested information regarding your practice is voluntary and will not be provided to any third party or otherwise be shared publicly. 
		Your participation is encouraged because this information will be used to evaluate the relevance and impact of credentialing for licensure, research 
		projects, marketing campaigns and targeted communications. </p>
	<div class="field">
		<div class="field__label-input-wrap">
			<label for="employmentStatus" class="label">What best describes your employment status? </label>
			<select class="input input--select-menu input--xlarge" id="employmentStatus" name="employmentStatus" formControlName="employmentStatus" [class.input--invalid]="formErrors.employmentStatus"
			(change)="employmentStatus($event.target.value)">
				<option value="null">Select One</option>
				<option *ngFor="let c of employmentStatusLov" [value]="c.codeValue">{{c.codeDescription}}</option>
			</select>
			<div *ngIf="formErrors.employmentStatus" class="error-message field__error-message">{{ formErrors.employmentStatus }}</div>
		</div>
	</div>
	<div class="field">
		<div class="field__label-input-wrap" *ngIf="employed">
			<label for="employmentSector" class="label">What best describes your employment sector? </label>
			<select class="input input--select-menu input--xlarge" id="employmentSector" name="employmentSector" formControlName="employmentSector" [class.input--invalid]="formErrors.employmentSector"
			(change)="employmentSector($event.target.value)">
				<option value="null">Select One</option>
				<option *ngFor="let c of employmentSectorLov" [value]="c.codeValue">{{c.codeDescription}}</option>
			</select>
			<div *ngIf="formErrors.employmentSector" class="error-message field__error-message">{{ formErrors.employmentSector }}</div>
		</div>
	</div>
	<div class="field">
		<div class="field__label-input-wrap" *ngIf="employed && workSectorRespiratory">
			<label for="employmentStates" class="label">In what state(s) do you hold a current, unrestricted license? (Select all that apply.) </label>
			<ng-multiselect-dropdown
			[settings]="dropdownSettings"
			[placeholder]="'Select All That Apply'"
			[data]="statesLov"
			[placeholder]="'Select All That Apply'"			
			formControlName="employmentStates"
			formControlArray="employmentStates"			
			>

			</ng-multiselect-dropdown>
			<div *ngIf="formErrors.employmentStates" class="error-message field__error-message">{{ formErrors.employmentStates }}</div>
		</div>
	</div>
	<div class="field">
		<div class="field__label-input-wrap" *ngIf="employed && workSectorRespiratory">
			<label for="workSetting" class="label">What best describes your <u>primary</u> work setting? </label>
			<select class="input input--select-menu input--xlarge" id="workSetting" name="employmentSector" formControlName="workSetting" [class.input--invalid]="formErrors.workSetting">
				<option value="null">Select One</option>
				<option *ngFor="let c of workSettingLov" [value]="c.codeValue">{{c.codeDescription}}</option>
			</select>
			<div *ngIf="formErrors.workSetting" class="error-message field__error-message">{{ formErrors.workSetting }}</div>
		</div>
	</div>

	<div class="field">
		<div class="field__label-input-wrap" *ngIf="employed && workSectorRespiratory">
			<label for="patientTypes" class="label">For which patient populations do you provide care? (Select all that apply.) </label>
				<ng-multiselect-dropdown
				[settings]="dropdownSettings"
				[placeholder]="'Select All That Apply'"
				[data]="patientTypeLov"
				formControlName="patientTypes"
				formControlArray="patientTypes"	
				>
	
				</ng-multiselect-dropdown>
			<div *ngIf="formErrors.patientTypes" class="error-message field__error-message">{{ formErrors.patientTypes }}</div>
		</div>
	</div>

	<div class="field">
		<div class="field__label-input-wrap" *ngIf="employed && workSectorRespiratory">
			<label for="jobRole" class="label">What is your <u>primary</u> job role? </label>
			<select class="input input--select-menu input--xlarge" id="jobRole" name="jobRole" formControlName="jobRole" [class.input--invalid]="formErrors.jobRole">
				<option value="null">Select One</option>
				<option *ngFor="let c of jobRoleLov" [value]="c.codeValue">{{c.codeDescription}}</option>
			</select>
			<div *ngIf="formErrors.employmentSector" class="error-message field__error-message">{{ formErrors.jobRole }}</div>
		</div>
	</div>	
	</section>

	<div class="form-actions">
		<input class="button form-actions__item" type="submit" value="Save" />
		<button (click)="cancel($event)" class="button button--secondary form-actions__item">Cancel</button>
	</div>
</form>